<template>
  <v-navigation-drawer
    v-model="drawer"
    :fixed="leftSideMenu"
    :absolute="!leftSideMenu"
    clipped
    dark
    temporary>
    <v-list 
      v-if="currentUser"
      class="pa-0">
      <v-list-tile avatar>
        <v-list-tile-avatar v-if="currentUser.photoURL">
          <img :src="currentUser.photoURL" >
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{ cropName(currentUser.customDisplayName) }}</v-list-tile-title>
          <v-list-tile-title>{{ currentUser.email }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="userSignOut">
        <v-list-tile-title><v-icon>power_settings_new</v-icon> {{ $t('page.authentication.logout') }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
    <v-divider />
    <!-- Events -->
    <v-list v-if="eventsFiltered && eventsFiltered.length > 0">
      <v-list-tile>
        <v-list-tile-title class="title">{{ $t(`menu.events`) }}</v-list-tile-title>
      </v-list-tile>
      <template v-if="loadings.clubs">
        {{ $t('general.loading') }}
      </template>
      <template v-if="dbErrors.clubs">
        {{ dbErrors.clubs }}
      </template>
      <template v-else>
        <v-list-tile 
          v-for="club in eventsFiltered" 
          :key="club.id"
          @click="navigateTo({name: 'WeekMatches', params:{clubId: club.id, year, week}})">
          <v-list-tile-title><v-icon>remove</v-icon> {{ club.club }}</v-list-tile-title>
        </v-list-tile>
      </template>
    </v-list>
    <v-divider />
    <!-- Clubs -->
    <v-list v-if="clubsFiltered && clubsFiltered.length > 0">
      <v-list-tile>
        <v-list-tile-title class="title">{{ $t(`menu.clubs`) }}</v-list-tile-title>
      </v-list-tile>
      <template v-if="loadings.clubs">
        {{ $t('general.loading') }}
      </template>
      <template v-if="dbErrors.clubs">
        {{ dbErrors.clubs }}
      </template>
      <template v-else>
        <v-list-tile 
          v-for="club in clubsFiltered" 
          :key="club.id"
          @click="navigateTo({name: 'WeekMatches', params:{clubId: club.id, year, week}})">
          <v-list-tile-title><v-icon>remove</v-icon> {{ club.club }}</v-list-tile-title>
        </v-list-tile>
      </template>
    </v-list>
    <v-divider />
    <v-list>
      <v-list-tile>
        <v-list-tile-title class="title">{{ $t(`menu.info`) }}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile @click="navigateTo({name: 'ChangeLog'})">
        <v-list-tile-title><v-icon>developer_board</v-icon> {{ $t(`menu.changelog`) }}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile @click="navigateTo({name: 'Tutorial'})">
        <v-list-tile-title><v-icon>help_outline</v-icon> {{ $t(`menu.tutorial`) }}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile @click="mailTo($t('site.email'))">
        <v-list-tile-title><v-icon>email</v-icon> {{ $t(`menu.contact`) }}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile @click="navigateTo({name: 'Privacy'})">
        <v-list-tile-title><v-icon>assignment</v-icon> {{ $t(`menu.privacy`) }}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile @click="navigateTo({name: 'Terms'})">
        <v-list-tile-title><v-icon>description</v-icon> {{ $t(`menu.terms`) }}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile @click="navigateTo({name: 'Cookies'})">
        <v-list-tile-title><v-icon>description</v-icon> {{ $t(`menu.cookies`) }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
    <v-divider />
    <v-list>
      <v-list-tile>
        <v-list-tile-title class="title">{{ version }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
    <!--
    <v-divider />
    <v-list v-if="currentUser && currentUser.superadmin">
      <v-list-tile>
        <v-list-tile-title class="title">{{ $t(`menu.title.admin`) }}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile @click="navigateTo({name: 'Sports'})">
        <v-list-tile-title><v-icon>directions_run</v-icon> {{ $t(`menu.sports`) }}</v-list-tile-title>
      </v-list-tile>
      <v-divider />
    </v-list>
    -->
  </v-navigation-drawer>
</template>
<script>
import ClubsLib from '@/lib/data/clubs'
import BaseMixin from '@/components/Dashboard/Mixin/BaseMixin'
import { mapState } from 'vuex'
import DateHelper from '@/lib/DateHelper'
import packageJson from '@/../package.json'
const debug = require('debug')('OD::LeftNavigationMenu')

export default {
  name: 'LeftNavigationMenu',
  mixins: [BaseMixin],
  data() {
    return {
      drawer: false,
      clubs: [],
      loadings: {
        clubs: true,
      },
      dbErrors: {
        clubs: null,
      },
    }
  },
  computed: {
    ...mapState({
      leftSideMenu: state => state.global.leftSideMenu,
    }),
    week() {
      return `${DateHelper.getWeekNumber()}`
    },
    year() {
      return `${DateHelper.getYearNumber()}`
    },
    version() {
      return packageJson.version
    },
    eventsFiltered() {
      debug('eventsFiltered', this.clubs)
      return this.clubs
        .filter(club => {
          return !club.hide && club.type === 'event'
        })
        .sort((a, b) => {
          if (a.club < b.club) return -1
          if (a.club > b.club) return 1
          return 0
        })
    },
    clubsFiltered() {
      debug('clubsFiltered', this.clubs)
      return this.clubs
        .filter(club => {
          return !club.hide && club.type === 'club'
        })
        .sort((a, b) => {
          if (a.club < b.club) return -1
          if (a.club > b.club) return 1
          return 0
        })
    },
  },
  watch: {
    currentUser() {
      this.init()
    },
    drawer() {
      if (this.drawer !== this.leftSideMenu) {
        this.toogleSideMenu()
      }
    },
    leftSideMenu() {
      this.drawer = this.leftSideMenu
    },
  },
  created() {
    this.init()
  },
  mounted() {
    this.bind()
  },
  beforeDestroy() {},
  methods: {
    bind() {
      ClubsLib.bindAll(this)
    },
    init() {
      this.drawer = this.leftSideMenu
    },
    toogleSideMenu() {
      this.$store.dispatch('global/toogleSideMenu')
    },
    navigateTo(to) {
      this.$router.push(to)
    },
    mailTo(email) {
      document.location.href = `mailto:${email}`
    },
    cropName(string) {
      if (string.indexOf('@') > -1) {
        string = string.slice(0, string.indexOf('@'))
      }
      const numMaxCharacters = 15
      if (string.length > numMaxCharacters) {
        return string.slice(0, numMaxCharacters) + '...'
      }
      return string
    },
    userSignOut() {
      this.$store.dispatch('user/logout')
    },
  },
}
</script>

<style lang="scss">
</style>
